import React, { useRef } from 'react';
import {
  TextField,
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  DateField,
  Datagrid,
} from 'react-admin';

import { Card } from '@material-ui/core';
import ReceiptIcon from '@material-ui/icons/Receipt';
import VisibilityIcon from '@material-ui/icons/Visibility';

import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api } from '../../services';
import { PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR } from '../../utils/dadosTelas';
import DialogoTesteNfceVenda from '../Vendas/DialogoTesteNfceVenda';
//import ActionsField from './ActionsField';
import Actions from './ActionsList';
import DialogoShow from './DialogoShow';
import StatusField from './StatusField';
//
const MyList = ({ ...props }) => {
  const refDialogoShow = useRef(null);
  const refresh = useRefresh();
  const refDialogoTesteNfceVenda = useRef(null);

  async function handleCriar() {
    const response = await api.put(`/notas-fiscais-testes/gerar`);
    const data = response.data;
    const { status, message } = data;
    refresh();
  }

  async function handleEnviarSefaz(record) {
    const response = await api.get(`/get-nfce-conjunto-produtos/${record.id}`);
    const data = response.data;
    if (refDialogoTesteNfceVenda.current) {
      refDialogoTesteNfceVenda.current.handleOpen(
        `Nfce Teste: ${record.id}`,
        JSON.stringify(data.sefaz, null, 2),
      );
    }
    refresh();
  }

  function handleShow({ id }) {
    if (refDialogoShow.current) {
      refDialogoShow.current.handleOpen(id);
    }
  }

  return (
    <>
      <ListToolbar
        filters={props.filters}
        actions={<Actions handleCriar={handleCriar} {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid {...props}>
          <TextField source="id" label="ID" sortable={false} />
          <StatusField source="status" label="Status" sortable={false} />
          <DateField source="data" label="Data" showTime sortable={false} />
          <ActionsField
            source="lalala"
            /*      handleEnviarSefaz={handleEnviarSefaz}
            handleShow={handleShow} */
            textAlign="right"
            label="Ações"
            sortable={false}
            actions={[
              {
                title: 'Nfce Teste',
                icon: <ReceiptIcon />,
                onClick: (record) => handleEnviarSefaz(record),
              },
              {
                title: 'Detalhes',
                icon: <VisibilityIcon />,
                onClick: (record) => handleShow(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
      </Card>
      <DialogoTesteNfceVenda ref={refDialogoTesteNfceVenda} />
      <DialogoShow ref={refDialogoShow} />
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const PostPanel = (props) => <div>{props.record.mensagem}</div>;

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_NOTAS_FISCAIS_TESTE_LISTAR}>
    <ContainerMyList
      {...props}
      expand={<PostPanel />}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      //filters={<Filter />}
      title="Notas Fiscais de Teste"
    />
  </ProtegerPagina>
);

export default List2;
